export default (props, e) => {
	let target;
	if(props.targetId != null) {
		 target = document.querySelector('input[id="' + props.targetId + '"]');
	}
	if(props.targetValue != null) {
		 target = document.querySelector('input[value="' + props.targetValue + '"]');
	}
	if(typeof (target) !== 'undefined') {
		target.click(e);
	}
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/webActions/autoSelect.js